import React, { Component } from 'react';
import axios from 'axios';
import config from '../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

export class ContactUs extends Component {
  constructor(props) {
    super(props);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Contact Us Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  render() {
    return (
      <div className="ContactUs">
        <h2>Contact Us</h2>
        <h3>By Email:</h3>
        <p><a href="mailto:axagi@axa.com.hk" target="_top">axagi@axa.com.hk</a></p>
        <h3>By Post</h3>
        <p>AXA General Insurance Hong Kong Limited</p>
        <h4>Main Office:</h4>
        <p>5/F AXA Southside</p>
        <p>38 Wong Chuk Hang Road</p>
        <p>Wong Chuk Hang</p>
        <p>Hong Kong</p>
        <h3>By Phone:</h3>
        <p>(852) 2523 3061</p>
        <h3>By Fax:</h3>
        <p>(852) 2810 0706</p>
        <div className="ebaoUtil__ButtonGroup">
          <button type="button" className="btn btn-axa" onClick={this.handleClick}>Back to Home</button>
        </div>
      </div>
    )
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/app/pages/ContactUs.js